import React, { memo, useEffect } from 'react';
import { AdjustableComponent } from '../../../../utils/hooks/useClasses';
import { useGetHealthDownload } from '../../services/healthcheckServices';

type DownloadHealthWidgetProps = {
  partnerId: string;
  callback: (dat: any) => void;
};

const DownloadHealthWidget: AdjustableComponent<
  DownloadHealthWidgetProps,
  {}
> = ({ callback, partnerId, classes }) => {
  const { downloadLoading, downloadData } = useGetHealthDownload(partnerId);

  useEffect(() => {
    if (downloadData) {
      callback(downloadData);
    }
  }, [downloadLoading, downloadData]);

  return <div style={{ visibility: 'hidden' }}></div>;
};
export default memo(DownloadHealthWidget);
